<template>
  <div
    class="wrapper pa-4"
  >
    <h1>载入3D模型（Loading 3D models）</h1>
    <canvas
      id="c"
      class="full-bleed"
    />
    <highlightjs
      class="mt-4"
      :code="`${code}`"
      :language="'js'"
    />
    <p><a href="https://sketchfab.com/3d-models/stylized-stones-props-5aacb1ff1dae459c9a3afb5098f7a571">石头模型下载 Stylized stones props</a></p>\
    <p><a href="https://sketchfab.com/3d-models/free-ac-unit-08223d7724f54639b06cb2b276b6d252">Free AC Unit</a></p>
  </div>
</template>

<script type="module">
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

const loader = new GLTFLoader();

export default {
  data() {
    return {
      fov: 75, // 相机视野范围
      aspect: 2, // 画布的宽高比 在默认情况下 canvas画布是300x150像素，所以宽高比为300/150或者说2
      near: 0.1, // 相机近平面
      far: 5, // 相机远平面

      boxWidth: 1,
      boxHeight: 1,
      boxDepth: 1,

      code: `// 加载 glb 文件
// 这个可以的 但是我在vue目录 和 /public里都放了一个
loader.load( 'stone.glb', function ( gltf ) {
  scene.add( gltf.scene );
}, undefined, function ( error ) {
  console.error( error );
} );

// 加载 gltf 文件 
// 放在 /public 里
loader.load( '/free_ac_unit/scene.gltf', function ( gltf ) {
  scene.add( gltf.scene );
}, undefined, function ( error ) {
  console.error( error );
} );

// 加载 gltf 文件
// 放在GitHub上文件路径有问题 铐
loader.load( '/stylized_stones_props/scene.gltf', function ( gltf ) {
  scene.add( gltf.scene );
}, undefined, function ( error ) {
  console.error( error );
} );`,
    };
  },
  mounted() {
    this.main();
  },
  methods: {
    main() {
      // canvas
      const canvas = document.querySelector('#c');
      // 渲染器 antialias代表是否开启抗锯齿
      const renderer = new THREE.WebGLRenderer({antialias: true, canvas});
      renderer.setSize( window.innerWidth, window.innerHeight - 300, false );
      const camera = new THREE.PerspectiveCamera(65,  window.innerWidth / window.innerHeight, 1, 500 );

      // 摄像机位置 xyz
      camera.position.set( 0, 0, 5);
      camera.lookAt( 0, 0, -0.2 );

      // 创建场景
      const scene = new THREE.Scene();

      // 几何体 宽 高 深
      const geometry = new THREE.BoxGeometry(1, 1, 1);

      // 材质
      const material = new THREE.MeshPhongMaterial({
        color: '#FFDD11',
      });

      // 再创建一个网格(Mesh)对象，它包含了 geometry(几何体 物体的形状) material(材质 如何绘制物体，光滑还是平整，什么颜色，什么贴图..)
      const cube = new THREE.Mesh(geometry, material);
      // 位置
      cube.position.set( 2, 0, 0 );
      // 最后我们将网格添加到场景中。
      scene.add(cube);

      // // 加载 glb 文件
      loader.load( 'stone.glb', function ( gltf ) {
        scene.add( gltf.scene );
      }, undefined, function ( error ) {
        console.error( error );
      } );

      // // 加载 gltf 文件 
      // loader.load( '/free_ac_unit/scene.gltf', function ( gltf ) {
      //   scene.add( gltf.scene );
      // }, undefined, function ( error ) {
      //   console.error( error );
      // } );

      // 加载 gltf 文件
      // 放在GitHub上文件路径有问题
      // loader.load( '/stylized_stones_props/scene.gltf', function ( gltf ) {
      //   scene.add( gltf.scene );
      // }, undefined, function ( error ) {
      //   console.error( error );
      // } );

      // 之后将场景和摄像机传递给渲染器来渲染出整个场景。
      renderer.render(scene, camera);

      // 灯光
      const color = 0xFFFFFF;
      const intensity = 3;
      const light = new THREE.DirectionalLight(color, intensity);
      light.position.set(-1, 2, 4); // 位置
      scene.add(light);

      // 判断画布是否需要调整大小
      function resizeRendererToDisplaySize(renderer) {
        const canvas = renderer.domElement;
        const width = canvas.clientWidth;
        const height = canvas.clientHeight;
        const needResize = canvas.width !== width || canvas.height !== height;
        if (needResize) {
          renderer.setSize(width, height, false);
        }
        return needResize;
      }

      // 立方体旋转
      function render(time) {
        time *= 0.001;  // 将时间单位变为秒

        // 注意如果我们的canvas大小被调整了那函数会返回true。我们可以利用 这个来检查是否有其他的东西应该更新。我们修改渲染循环 来使用我们的新函数
        if (resizeRendererToDisplaySize(renderer)) {
          const canvas = renderer.domElement;
          camera.aspect = canvas.clientWidth / canvas.clientHeight;
          camera.updateProjectionMatrix();
        }
      
        cube.rotation.x = time;
        cube.rotation.y = time;
      
        renderer.render(scene, camera);
      
        requestAnimationFrame(render);
      }
      requestAnimationFrame(render);
    },
  }
}
</script>

<style scoped>
.wrapper {
  display: grid;
  grid-template-columns:
    1fr
    min(65ch, 100%)
    1fr;
}

.wrapper > * {
  grid-column: 2;
}

.full-bleed {
  width: 100%;
  grid-column: 1 / -1;
}

/* 移动端换行 */
a {
  word-break: break-all;
}

</style>